import { periodNumberFor, periodStartDate } from '../../lib/payPeriods'
import { currentDetailFor, type PersonnelDetail } from './personnelDetailStore'

export type PersonnelStatus = 'active' | 'detailed'

// The real current date, not one threaded through every caller: a
// detail's own start and end dates are real calendar dates a supervisor
// picks (DetailForm.tsx), unrelated to the pilot's own fixed 14-day DAYS
// array, so there is no period-fallback here the way TODAY_INDEX has
// elsewhere for that.
function todayIsoDate(): string {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

// A detail (personnelDetailStore.ts) only marks the employee Detailed while
// today actually falls within its own effective dates: one scheduled to
// start later, or one that has already ended, leaves them Active.
export function effectiveStatusFor(
  person: { id: string },
  details: PersonnelDetail[],
): { status: PersonnelStatus; detailLabel?: string; detailEndDate?: string } {
  const detail = currentDetailFor(details, person.id, todayIsoDate())
  if (!detail) return { status: 'active' }
  return {
    status: 'detailed',
    detailLabel: `${detail.type} · ${detail.destination}, ${detail.startDate}–${detail.endDate}`,
    detailEndDate: detail.endDate,
  }
}

// docs/product/scheduling-model.md's "the earliest effective date for a
// transfer is the first day of the pay period after the detail ends."
// Whichever period the detail's own end date falls in, however far from
// today that is, the first day of the period right after it is the
// answer: periodNumberFor/periodStartDate (src/lib/payPeriods.ts) handle
// that conversion in both directions, so there is nothing here specific
// to any one period number.
export function firstDayAfterDetailEnds(endDate: string): string {
  return periodStartDate(periodNumberFor(endDate) + 1)
}
